import { useSalesChannelContent } from 'src/hooks/useSalesChannelContent';
//import { useI18n } from 'src/hooks/useRouterChange';
//import { i18nGet } from 'src/tools/tools';
//import { get } from 'lodash';
import {
  useEffect,
  useRef,
  //useEffect, useRef,
  useState,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useForms } from './useForms';
import sync from 'src/strategies/profile';
import { get } from 'lodash';
import defaultData from '../default';
import { useI18n } from '@/src/hooks/useRouterChange';
import { msg } from '@/src/tools/message';
import { modal } from '@/src/utils/Modal';
import { i18nGet } from '@/src/tools/tools';
import { useRequest } from 'ahooks';
import {
  getContentProfilePage_revamp,
  postContentProfilePage_revamp,
} from '@/src/request/salesChannel/content';
import { useQueryLanguageListContentEditor } from '@/src/constrains/SalesChannelMultiLanguageSelect';
import { checkAll } from '../validator';
import { EPreviewSize } from '@/src/types/common/SalesChannel';
//import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
const useProfile = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    params,
    salesChannelMultiLanguageQueryParams,
    salesChannel,
    selectedLanguage,
    salesChannelMultiLanguageParams,
  } = useSalesChannelContent();
  const { pcForm, mobileForm, tabletForm } = useForms();
  const { saleChannelUuid, contentUuid } = params;
  const copyOfOriginal = useRef<any>(null);
  const _history = useHistory();
  const isLive =
    get(copyOfOriginal.current, 'salesChannelContent.status') === 'Live';
  const [hasModified, setHasModified] = useState(false);
  const [loaded, setLoaded] = useState(false);

  const submitParams = salesChannelMultiLanguageParams;
  const queryParams = salesChannelMultiLanguageQueryParams;
  const currentLanguage = useQueryLanguageListContentEditor();

  const onGoBack = () => {
    _history.push(`/salesChannel/content/${saleChannelUuid}`);
  };

  const handleOnDataGet = async (data) => {
    copyOfOriginal.current = data;
    if (!data?.pc && !data?.tablet && !data?.mobile) {
      pcForm.setFieldsValue(defaultData.pc);
      tabletForm.setFieldsValue(defaultData.tablet);
      mobileForm.setFieldsValue(defaultData.mobile);
    } else {
      const pcData = data?.pc;
      const tabletData = data?.tablet;
      const mobileData = data?.mobile;
      pcForm.setFieldsValue(pcData);
      //pcForm.validateFields();
      tabletForm.setFieldsValue(tabletData);
      //tabletForm.validateFields();
      mobileForm.setFieldsValue(mobileData);
      // mobileForm.validateFields();
    }
    setTimeout(() => {
      setLoaded(true);
    }, 1000);
  };

  const { run } = useRequest(
    (queryParams) => {
      return getContentProfilePage_revamp(contentUuid, queryParams);
    },
    { manual: true, onSuccess: handleOnDataGet },
  );

  const { run: onSubmit } = useRequest(postContentProfilePage_revamp, {
    manual: true,
    onSuccess: (d) => {
      handleOnDataGet(d);
    },
  });

  const onFetch = (queryParams) => {
    run(queryParams);
  };

  const handleOnSubmit = async () => {
    const pD = pcForm.getFieldsValue();
    const tD = tabletForm.getFieldsValue();
    const mD = mobileForm.getFieldsValue();
    const pR = checkAll(pD);
    const tR = checkAll(tD);
    const mR = checkAll(mD);
    if (
      (!get(pR, 'hasError') &&
        !get(tR, 'hasError') &&
        !get(mR, 'hasError') &&
        isLive) ||
      !isLive
    ) {
      const data = {
        ...(copyOfOriginal.current || {}),
        pc: pD,
        tablet: tD,
        mobile: mD,
      };
      await onSubmit(data, submitParams);
      msg.success(getI18n('general.savesuccess'));
      setHasModified(false);
    } else {
      modal.error({
        title: getI18n('general.unabletosavechanges'),
        content: getI18n('general.fixerrors'),
        onOk: () => {
          return;
        },
      });
    }
  };

  const handleFieldsChange = (changeFields: Array<any>) => {
    setHasModified(true);
    sync(changeFields, { pcForm, tabletForm, mobileForm });
  };

  useEffect(() => {
    onFetch(queryParams);
  }, [currentLanguage]);

  const handleOnReset = (fields: Array<any>, breakpoint) => {
    if (breakpoint === EPreviewSize.TABLET) {
      tabletForm.setFields(
        fields.map((key) => {
          const v = get(defaultData.tablet, key);
          return {
            name: key,
            value: v ? v : null,
          };
        }),
      );
    }
    if (breakpoint === EPreviewSize.MOBILE) {
      mobileForm.setFields(
        fields
          .map((key) => {
            const v = get(defaultData.mobile, key);
            if (!!v) {
              return {
                name: key,
                value: v,
              };
            }
          })
          .filter((v) => !!v),
      );
    }
  };

  const handleOnCopy = async (fields: Array<any>, breakpoint) => {
    const pcValues = pcForm.getFieldsValue(true);
    if (breakpoint === EPreviewSize.TABLET) {
      tabletForm.setFields(
        fields.map((key) => {
          const v = get(pcValues, key);
          return {
            name: key,
            value: v,
          };
        }),
      );
      await tabletForm.validateFields(fields);
    }
    if (breakpoint === EPreviewSize.MOBILE) {
      mobileForm.setFields(
        fields.map((key) => {
          const v = get(pcValues, key);
          return {
            name: key,
            value: v,
          };
        }),
      );
      await mobileForm.validateFields(fields);
    }
  };

  const handleOnDiscard = async () => {
    if (hasModified) {
      //const data = submitData();
      //await handleAddDraft(selectedLanguage, data?.submitData);
    }
    onGoBack();
  };

  return {
    salesChannel,
    selectedLanguage,
    hasModified,
    loaded,
    onGoBack,
    handleOnReset,
    handleOnCopy,
    setHasModified,
    handleFieldsChange,
    handleOnSubmit,
    handleOnDiscard,
    pcForm,
    mobileForm,
    tabletForm,
    data: copyOfOriginal.current,
  };
};
export { useProfile };
